import React from 'react'
import { Switch } from 'react-router-dom'

import { Paths } from 'src/constants/navigation'
import { FjRoute } from 'src/hoc/FjRoute'
import { HomeRedirectRoute } from 'src/hoc/RedirectRoute'
import { Academy } from 'src/pages/Academy'
import { Library } from 'src/pages/Library'
import { Unsubscribe } from 'src/pages/Unsubscribe'
import { sharedAppStateStore } from 'src/store/AppStateStore'

const baseRoutes = () => {
  return (
    <Switch>
      <HomeRedirectRoute exact path="/" />
      <FjRoute exact path={Paths.unsubscribe} component={Unsubscribe} />
      <FjRoute exact path={Paths.academy} component={Academy} />
      <FjRoute exact path={Paths.library} private={!sharedAppStateStore.externalAcademy} component={Library} />
    </Switch>
  )
}

export default baseRoutes
